import NProgress from 'nprogress'

NProgress.configure({
    easing: 'ease',
    speed: 500,
    showSpinner: true,
    template: '<div class="bar" role="bar"><div class="peg"></div></div></div>',
})

const state = {
    loadingCount: 0,
}

const mutations = {
    START_LOADING: (state) => state.loadingCount++,
    FINISH_LOADING: (state) => setTimeout(() => state.loadingCount--, 250),
}

const actions = {
    start({ commit, state, getters }) {
        const before = getters.isLoading
        const beforeCount = state.loadingCount
        commit('START_LOADING')
        if (!before) NProgress.start()
        else NProgress.set(1.8 / Math.max(beforeCount, state.loadingCount))
    },

    finish({ commit }) {
        if (!getters.isLoading) return
        NProgress.done()
        commit('FINISH_LOADING')
    },
}

const getters = {
    isLoading: (state) => state.loadingCount > 0,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
